<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Oasis. IBS v{{version}}
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Designed & Developed by Oasis Computer Systems
                </div>
            </div>
        </div>
    </div>
</footer>